import { Injectable } from '@angular/core';
import { GlobalsService } from 'app/_services/globals.service';
import { LogService } from 'app/_services/logmanager.service';
import { AppConfig } from 'app/app.config';

declare let $: any;

@Injectable()
export class FileDownloadService {

    constructor(
        private globalStorage: GlobalsService,
        private config: AppConfig
    ) {}

    public download (url: string, params: any, wname = '_blank'): void {

        // Obtenemos el token
        const currentuseri = this.globalStorage.getItem('currentUser');
        const currentuser = JSON.parse(currentuseri);

        const form = document.createElement('form');
        form.action = url;
        form.method = 'POST';
        form.target = wname;
        form.style.display = 'none';

        const submit = document.createElement('input');
        submit.type = 'submit';
        submit.id = '_downloadFile_';
        form.appendChild(submit);

        let input = document.createElement('input');
        input.type = 'text';
        input.name = 'token';
        input.value = currentuser.token;
        form.appendChild(input);

        for (const item in params) {
            if (params.hasOwnProperty(item)) {
                LogService.log('FileDownloadService', params[item]);
                input = document.createElement('input');
                input.type = 'text';
                input.name = item;
                input.value = params[item];
                form.appendChild(input);
            }
        }

        document.body.appendChild(form);

        $('#_downloadFile_').click();

        document.body.removeChild(form);
    }
    

    public downloadHandler(fileId: string, personaId){
        const ruta = this.config.apiUrl + this.config.downloadRoute;
        const wname = '_download_';
        const params = <any>{
            'accio': 'WsDownloadDoc',
            'file': fileId,
            'userId':   personaId,
        };
  
        this.download(ruta, params, wname);
        
        return false;
    }
}
